import { render, staticRenderFns } from "./StaticPageInfo.vue?vue&type=template&id=01febdca&"
import script from "./StaticPageInfo.vue?vue&type=script&lang=js&"
export * from "./StaticPageInfo.vue?vue&type=script&lang=js&"
import style0 from "./StaticPageInfo.vue?vue&type=style&index=0&id=01febdca&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01febdca')) {
      api.createRecord('01febdca', component.options)
    } else {
      api.reload('01febdca', component.options)
    }
    module.hot.accept("./StaticPageInfo.vue?vue&type=template&id=01febdca&", function () {
      api.rerender('01febdca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StaticPageInfo.vue"
export default component.exports